<template>
  <div>
    <div class="main-container">
      <div class="container hidden-sm-and-down">
         <div class="Shopping">
        <h4>
          我的购物车
          <router-link
            to="/Product"
            class="hidden-xs-only"
            style="float: right;color: #00383F;"
            >继续购物>></router-link>
        </h4>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          class="hidden-xs-only"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="">
            <template slot-scope="scope"><span><img
                  class="cover"
                  :src="imgsrc + scope.row.cover"
                  alt="" />
              </span>
            </template>
          </el-table-column>
          <el-table-column label="商品信息">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
              <br />
              <span class="taocan">{{ scope.row.specs.group }}</span>
            </template>
          </el-table-column>
          <el-table-column label="数量">
            <template slot-scope="scope">
              <el-input-number
                :precision="0"
                size="mini"
                v-model="scope.row.num"
                :min="1"
                :max="99"
                @change="handleChange(scope.row.id, scope.row.num)"
                @blur="numChange(scope.row.id, scope.row.num)"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="单价">
            <template slot-scope="scope"
              ><span>￥{{ (+ scope.row.specs.price).toFixed(2) }}</span></template
            >
          </el-table-column>
          <el-table-column label="总计">
            <template slot-scope="scope"
              ><span
                >￥{{ (scope.row.num * scope.row.specs.price).toFixed(2) }}</span
              ></template
            >
          </el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope" style="text-align: left">
              <el-button
                @click.native.prevent="deleteRow(scope.$index, tableData)"
                type="text"
                size="small"
                style="color: #000"
              >
                <i class="el-icon-error" style="color: red; font-size: 14px"></i>&nbsp;删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="24">
            <div class="submit_box">
              <span class="submit" @click="ordersin">结算</span>
              <p>总计: ￥{{ goodsPrice.toFixed(2) }}</p>
              <p>已选{{ goodsNumber }}件商品</p>
            </div>
          </el-col>
        </el-row>
      </div>
      </div>
      <!-- 手机端显示 -->
      <div class="shopcon hidden-md-and-up">
        <p class="title">我的购物车</p>
          <el-table  ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 95%;margin:0 auto;"
          @selection-change="handleSelectionChange">
          <el-table-column  width="25" type="selection"> </el-table-column>
            <el-table-column min-width="40%">
                <template slot-scope="scope" >
                    <div class="productimg">
                      <img :src="imgsrc + scope.row.cover"/>
                    </div>
                </template>
            </el-table-column>
            <el-table-column>
                <template slot-scope="scope" class="productdetail">
                    <p class="proname">{{scope.row.name}}</p>
                    <p class="proprice">￥{{ (+ scope.row.specs.price).toFixed(2) }} <span>总计:￥{{ (scope.row.num * scope.row.specs.price).toFixed(2) }}</span></p>
                    <div class="num">
                        <span>数量：</span>
                       <el-input-number :precision="0" size="mini" v-model="scope.row.num"
                      :min="1"
                      :max="99"
                      @change="handleChange(scope.row.id, scope.row.num)"
                      @blur="numChange(scope.row.id, scope.row.num)">
                    </el-input-number>
                          <el-button
                          @click.native.prevent="deleteRow(scope.$index, tableData)"
                          type="text"
                          size="small"
                          style="color: #000">
                          <i class="el-icon-error" style="color: red; font-size: 0.24rem;margin-right: 0.1rem;"></i>删除
                        </el-button>
                    </div>
                   
                </template>
            </el-table-column>
        </el-table>
        <div class="submitbox">
            <div>总计: ￥{{ goodsPrice.toFixed(2) }}</div>
            <div> <router-link to="/Product">继续购物</router-link></div>
           <div class="submit" @click="ordersin">去结算{{ goodsNumber }}(件)</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  create_shoppingshow_url,
  destroy_shopping_car_url,
  edit_shopping_car_url,
} from "../request/api.js";
export default {
  name: "Shopping",
  components: {},
  directives: {},
  data() {
    return {
      tableData: [],
      multipleSelection: [],
      goodsPrice: 0,
      goodsNumber: 0,
      selectshop: [],
      selectshopId: "",
      kaiguan: "",
      mytime: 0,
      mytimeout: "",
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.selectshop = val;
      this.selectshopId = "";
      this.goodsNumber = 0;
      this.goodsPrice = 0;
      for (var num = 0; num < val.length; num++) {
        this.selectshopId += val[num].id + ",";
        this.goodsNumber += parseInt(val[num].num);
        this.goodsPrice += val[num].num * val[num].specs.price;
      }
    },
    //结算
    ordersin() {
      if (!this.$store.state.isLogin) {
        this.$router.push({ path: "/Login" });
      } else {
        if (this.selectshop != "") {
          this.$cookies.set("id", this.selectshopId);
          this.$router.push({ path: "/ordersIn", query: { page: "s" } });
        } else {
          this.$message.error("请选择商品");
        }
      }
    },
    //购物车列表
    getShoppingCar() {
      create_shoppingshow_url().then((res) => {
        this.tableData = res.data.data;
      });
    },
    //商品加减
    numChange(id, val) {
      console.log(id);
      for (var i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].num == undefined) {
          this.tableData[i].num = 1;
          edit_shopping_car_url({ id: id, num: 1 }).then((res) => {});
        } else {
          edit_shopping_car_url({ id: id, num: val }).then((res) => {});
        }
      }
    },
    handleChange(id, val) {
      let _this = this;
      if (!_this.$store.state.isLogin) {
        _this.$router.push({ path: "/Login" });
      } else {
        _this.mytime = new Date().getTime();
        clearTimeout(_this.mytimeout);
        _this.mytimeout = setTimeout(function () {
          if (new Date().getTime() - _this.mytime > 500) {
            if (val != _this.kaiguan) {
              _this.numChange(id, val);
              _this.kaiguan = val;
            }
          }
        }, 600);
        _this.goodsNumber = 0;
        _this.goodsPrice = 0;
        for (let num1 = 0; num1 < _this.selectshop.length; num1++) {
          _this.goodsNumber += parseInt(_this.selectshop[num1].num);
          _this.goodsPrice +=
            _this.selectshop[num1].num * _this.selectshop[num1].specs.price;
        }
      }
    },
    // 删除商品
    deleteRow(index, rows) {
      destroy_shopping_car_url({ detele_id: rows[index].id + "," }).then(
        (res) => {
          console.log(res.data);
          if (res.data.code === 200) {
            this.$store.dispatch("getCarCount");
            this.$message.success(res.data.message);
            rows.splice(index, 1);
          }
        }
      );
      //
    },
  },
  mounted() {
    if (!this.$store.state.isLogin) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getShoppingCar();
    }
  },
};
</script>

<style lang="less" scoped>
/deep/.el-table{
  border-bottom: 1px solid #00383F!important;
}
/deep/.el-checkbox__inner::after{
  border:1px solid #00383F!important;
  border-left: 0!important;
    border-top: 0!important;
}
/deep/.el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: unset!important;
    border-color: #00383F!important;
    cursor: not-allowed;
}
.container{
   width: 100%;
     color: #00383F;
}
.Shopping {
  width: 85%;
  max-width: 1300px;
  margin: 0 auto;
  padding-top:6%;
  h4{
    text-align: left;
    font-size: 24px;
    font-weight: 400;
    margin-bottom: 1%;
  }
  .cover {
    width: 100%;
    max-width: 130px;
  }
  .submit_box {
    overflow: hidden;
    margin: 50px 0;
    p{
      display: inline-block;
      float: right;
      
    }
    .submit{
      display: inline-block;
      width: 10%;
      padding: 1% 0;
      background: #00383F;
      border-radius: 5px;
      color: #fff;
    }
  }

  .submit_box > * {
    float: right;
    font-size: 18px;
    height: 100%;
    display: inline-block;
    padding: 10px 30px;
  }
}
 @media (max-width: 991px) {
   .shopcon{
      .productimg{
             width: 1.367rem;
              height: 2rem;
              background: url(../../static/mobile/product.png) no-repeat;
              background-size: 100% 100%;
              border: 1px solid #00383F ;
              
              img{
                width: 100%;
                padding-top: 0.27rem;
                
                // padding-bottom: 0.53rem;
              }
      }
      .title{
        font-size: 0.38rem;
        font-weight: 900;
        padding-top: 1rem;
        padding-bottom: 0.59rem;
      }
      .productdetail{
        text-align: left;
      
      }
      .submitbox{
        width: 100%;
        height: 0.99rem;
        line-height: 0.99rem;
        border-top: 0.01rem solid rgba(0, 56, 63, 0.5);
        position: fixed;
        background: #FBFBFB;
        bottom: 0;
        left: 0;
        z-index: 999;
        display: flex;
        div{
          width: 3.3rem;
          font-size: 0.3rem;
        }
  
           div:nth-child(2){
              text-align: right;
              a{
                font-weight: bold;
                color: #00383F;
                font-size: 0.3rem;
                padding-right: 0.49rem;
              }
     
        }
          div:nth-child(3){
              background: #00383F;
              color: #fff;
        }
      }
   }
   /deep/.el-table thead{
     display: none;
   }
 /deep/.el-table__row{
   td:nth-child(3){
    //  width: 1.36rem!important;
    //  background: red;
     .cell{
       height: 2.5rem;
        padding: unset;
        text-align: left;
        line-height: unset;
          .proname{
          font-size: 0.32rem;
          padding-top: 0.3rem;
          font-weight: bold;
        }
        .proprice{
          font-size: 0.24rem;
          margin-top: 0.42rem;
          margin-bottom: 0.21rem;
          span{
            display: inline-block;
            margin-left: 0.99rem;
            vertical-align: unset;
          }
        }
        .num{
          span{
            font-size: 0.24rem;
          }
        .el-button--small{
          margin-left: 0.5rem;
        }
        }
     }
   }
 }
//  /deep/.el-table .cell{
//    height: 2rem;
//  }
/deep/.el-table .el-table__cell{
  padding: 0.3rem 0 0.6rem 0;
}
/deep/.el-table__row{
  td:nth-child(1){
    width: 0.2rem;
    .cell{
      float: left;
      padding-left: 0.1rem;
    }
  }
}
  /deep/.el-input--mini .el-input__inner{
            height: 0.4rem;
            width: 1.5rem;
            font-size: 0.18rem;
            line-height: 0.39rem;
            padding: unset;
            border-radius: unset;
          }
          /deep/.el-input-number{
            width: 1.5rem;
          }
  /deep/.el-input-number__increase{
     height: 0.38rem;
     line-height: 0.38rem;
      width: 0.48rem;
  }
  /deep/.el-input-number{
    line-height: 0.3rem;
  }
  /deep/.el-input-number__decrease{
    width: 0.48rem;
     height: 0.38rem;
     line-height: 0.38rem;
  }
 }
</style>


// WEBPACK FOOTER //
// src/view/Shopping.vue